import type { Locale } from './site'

type Localized = Record<Locale, string>

export type TutorialSlide = {
  id: string
  src: string
  title: Localized
  description: Localized
}

export const payekoohTutorialSlides: TutorialSlide[] = [
  {
    id: 'start',
    src: '/images/payekooh/tutorial/demo-01.svg',
    title: { fa: 'شروع ثبت مسیر', en: 'Start recording your route' },
    description: { fa: 'از نمای نقشه روی «شروع» بزنید تا ثبت مسیر تازه آغاز شود. پیش از حرکت، وضعیت GPS و شارژ دستگاه را بررسی کنید.', en: 'Start a new route from the map view. Check your GPS signal and battery before setting off.' },
  },
  {
    id: 'recording',
    src: '/images/payekooh/tutorial/demo-02.svg',
    title: { fa: 'ضبط فعالیت در جریان است', en: 'Track recording in progress' },
    description: { fa: 'پس از شروع، مدت‌زمان و مسافت فعالیت در پنل ثبت نمایش داده می‌شوند و می‌توانید ضبط را مدیریت کنید.', en: 'Once tracking starts, elapsed time and distance appear in the activity panel, where you can manage recording.' },
  },
  {
    id: 'details',
    src: '/images/payekooh/tutorial/demo-03.svg',
    title: { fa: 'مشاهده اطلاعات لحظه‌ای', en: 'See live activity details' },
    description: { fa: 'با باز کردن پنل جزئیات، شاخص‌های مسیر مانند زمان، مسافت و سرعت را هنگام حرکت مرور کنید.', en: 'Expand activity details to review metrics such as elapsed time, distance and pace while you move.' },
  },
  {
    id: 'photo',
    src: '/images/payekooh/tutorial/demo-04.svg',
    title: { fa: 'ثبت عکس در یک نقطه', en: 'Attach a photo to a location' },
    description: { fa: 'برای ثبت یک نقطه مهم روی مسیر، تصویر آن را اضافه کنید یا بدون تصویر به مرحله بعد بروید.', en: 'Document an interesting waypoint with a photo, or move on without attaching one.' },
  },
  {
    id: 'waypoint',
    src: '/images/payekooh/tutorial/demo-05.svg',
    title: { fa: 'تکمیل جزئیات نقطه', en: 'Describe your waypoint' },
    description: { fa: 'نوع نقطه، مانند نگاره، آبشار یا گذرگاه را انتخاب کنید و در صورت نیاز توضیحی بنویسید.', en: 'Choose a waypoint type, such as a viewpoint, waterfall or crossing, and add an optional note.' },
  },
  {
    id: 'finish',
    src: '/images/payekooh/tutorial/demo-06.svg',
    title: { fa: 'پایان فعالیت', en: 'Finish the outing' },
    description: { fa: 'پس از اتمام مسیر، ضبط را پایان دهید و خلاصه فعالیت را پیش از ذخیره بررسی کنید.', en: 'End the recording and review your activity summary before saving the trail.' },
  },
  {
    id: 'saved',
    src: '/images/payekooh/tutorial/demo-07.svg',
    title: { fa: 'ذخیره مسیر ثبت‌شده', en: 'Save the recorded track' },
    description: { fa: 'مسیر ثبت می‌شود؛ حالا می‌توانید انتشار آن را ادامه دهید یا تکمیل اطلاعات را به زمان دیگری موکول کنید.', en: 'Your route is saved. You can continue preparing it for publication or complete the details later.' },
  },
  {
    id: 'naming',
    src: '/images/payekooh/tutorial/demo-08.svg',
    title: { fa: 'انتخاب نام مناسب', en: 'Name the route' },
    description: { fa: 'یک عنوان کوتاه و قابل‌شناسایی برای مسیر بنویسید تا پیدا کردن و مرور دوباره آن ساده‌تر شود.', en: 'Give the track a short, descriptive name so you can find and revisit it more easily.' },
  },
  {
    id: 'review',
    src: '/images/payekooh/tutorial/demo-09.svg',
    title: { fa: 'بازبینی و تأیید نهایی', en: 'Review and confirm' },
    description: { fa: 'آمار مسیر و اطلاعات ثبت‌شده را بررسی کنید؛ در صورت نیاز پیش از تأیید، مسیر را ویرایش کنید.', en: 'Review route statistics and saved details. Make any changes before confirming the track.' },
  },
  {
    id: 'sync',
    src: '/images/payekooh/tutorial/demo-10.svg',
    title: { fa: 'همگام‌سازی اطلاعات', en: 'Sync route information' },
    description: { fa: 'در صورت اتصال به اینترنت، مسیر، نقاط و تصویرهای آن با سرور همگام می‌شوند. وضعیت ارسال را تا پایان بررسی کنید.', en: 'When connected, routes, waypoints and photos can sync with the server. Check progress until transfer completes.' },
  },
]
